import { FormControl, FormGroup } from 'shared/libs/form';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { SearchCityStore } from './SearchCityStore';
import { Validators } from 'core/services/Validators';
import { AsyncState } from 'shared/libs/state';
import { HttpClient } from 'shared/libs/http';

export class RegisterOrLoginStore {
   public readonly searchCityStore: SearchCityStore;

   private checkUserAsyncState = new AsyncState<any>();
   successMessage: string = '';

   readonly form = new FormGroup(
      {
         first_name: new FormControl<string>('', [Validators.required, Validators.nameValidator]),
         last_name: new FormControl<string>('', [Validators.required, Validators.nameValidator]),
         contact: new FormControl<string>('', [Validators.contactNumber]),
         email_address: new FormControl<string>('', [Validators.email]),
         birthday: new FormControl<string>('', [Validators.required]),
         city_id: new FormControl<string>('', [Validators.required]),
      },
      [
         (controls) => {
            if (
               controls['email_address'].value.trim() === '' &&
               controls['contact'].value.trim() === '' &&
               (controls['email_address'].dirty || controls['contact'].dirty)
            ) {
               return { contact: 'Вкажіть телефон або email для зв’язку та підтвердження відгуку' };
            }
            return {};
         },
      ]
   );

   constructor() {
      makeObservable(this, {
         successMessage: observable,
         checkUserProccessing: computed,
      });
      this.searchCityStore = new SearchCityStore();
   }

   get checkUserProccessing(): boolean {
      return this.checkUserAsyncState.status === 'pending';
   }

   checkUser = async ({
      onSuccess,
      onError,
   }: { onSuccess?: (msg: string) => void; onError?: () => void } = {}) => {
      await this.checkUserAsyncState.run(
         () => HttpClient.post('/jobApply/checkUser', this.form.value),
         {
            onSuccess: (resp) => {
               if (resp.status === 200) {
                  runInAction(() => {
                     this.successMessage = resp.message;
                  });
                  onSuccess?.(resp.message);
               }
            },
            onError: (e) => {
               onError?.();
            },
         }
      );
   };
}
